import {ChangeDetectionStrategy, Component, HostBinding, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {Project} from 'src/app/core/model/project';
import {CurrentSkedTask} from 'src/app/core/model/task';
import {OphIconModule} from 'src/app/shared/design/oph-icon/oph-icon.module';
import {RewardCoinIconPipe} from 'src/app/shared/pipes/reward-coin-icon.pipe';

@Component({
  selector: 'current-sked-task-detail-info',
  standalone: true,
  imports: [OphIconModule, MatIconModule, RewardCoinIconPipe],
  templateUrl: './current-sked-task-detail-info.component.html',
  styleUrl: './current-sked-task-detail-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentSkedTaskDetailInfoComponent {
  @Input() task: CurrentSkedTask;
  @Input() name: string;
  @Input() project: Project;
  @Input() coinTypeName: string;
  @Input() isMobile = false;
  @Input() showProjectAndCoin: boolean = true;

  @HostBinding('class.desktop-bg')
  get isDesktop(): boolean {
    return !this.isMobile;
  }

  @HostBinding('class.mobile-bg')
  get isMobileView(): boolean {
    return this.isMobile;
  }
}
